import { createSlice } from "@reduxjs/toolkit";
import { getTerrains } from "../actions/map";
import { Terrain } from "../../interfaces/terrain";

interface InitialState {
    terrainsLoaded: boolean,
    terrains: Terrain[] | null;
}

const initialState: InitialState = {
    terrainsLoaded: false,
    terrains: null
}

export const terrainSlice = createSlice({
    name: 'terrain',
    initialState, 
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTerrains.fulfilled, (state, { payload }) => {
                state.terrains = payload.map((terrain, index) => {
                    return {
                        ...terrain,
                        visible: index == 0
                    }
                })
                state.terrainsLoaded = true;
            })

    }
})